import * as React from 'react';
import { Row, Button, Col } from 'antd';
import { FormCard } from 'Components/Form/FormCard';
import { download } from 'utils/download';
import { notificationError } from 'utils/libHelpers/AntdNotification';
import { API } from 'General/API';
import { API_URL } from 'General/APIEndpoints';
import { withTranslation, WithTranslation } from 'react-i18next';
import { I18N_NS } from 'Config/i18n';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface ReportCardProps extends WithTranslation { }

export const ReportCard = withTranslation(I18N_NS.PROJECT)(
  class extends React.Component<ReportCardProps, { loading: boolean }> {
    constructor(props: ReportCardProps) {
      super(props);
      this.state = {
        loading: false
      };
    }

    downloadReport = async () => {
      const { t } = this.props;
      this.setState({ loading: true });
      try {
        const file = await API.getBlob(API_URL.ADMIN_REPORT.getBillingReport());
        download(file, `Billing report.xls`, 'text/vnd.ms-excel');
        this.setState({ loading: false });
      } catch (err) {
        this.setState({ loading: false });
        notificationError(t('Error'), t('Failed to download'));
        throw (err);
      }
    }

    render() {
      const { t } = this.props;
      return (
        <FormCard title={t('Reports')} className="mb-2">
          <Row
            gutter={16}
            justify="space-between"
            align="middle"
          >
            <Col>
              <span>{t('Billing report')}</span>
            </Col>
            <Col>
              <Button
                // size="small"
                loading={this.state.loading}
                type="primary"
                onClick={this.downloadReport}
              >
                <FontAwesomeIcon icon={['far', 'file-excel']} fixedWidth={true} />
                <span style={{ marginLeft: '5px' }}>
                  {this.state.loading ? t('Loading...') : t('Export')}
                </span>
              </Button>
            </Col>
          </Row>
        </FormCard>
      );
    }
  }
);